import { Dispatch, SetStateAction } from 'react'

export const createOrderChangeHandler = (
  setOrderBy: Dispatch<SetStateAction<string | undefined>>,
  setOrder: Dispatch<SetStateAction<'asc' | 'desc' | undefined>>
) => (orderBy: string, order: 'asc' | 'desc') => {
  setOrderBy(orderBy)
  setOrder(order)
}
